import { generateClient } from 'aws-amplify/api'
import { triggerDashboardDigestNow as triggerDashboardDigestNowMutation } from '@/graphql/mutations'
import { parseAwsJson } from '@/utils/graphql'
import { getApiMessage } from '@/mixins/Extras/ApiResponse'

const client = generateClient()

/**
 * "Send now" for Dashboard Digest -- fires an immediate send using whatever
 * is CURRENTLY SAVED for this scope (organization/product/campaign), so the
 * host screen must call this only after its own save has already succeeded,
 * not from unsaved form state. Shared across the three places
 * DashboardDigestSettings.vue is embedded (CampaignDetailPage.vue,
 * ContextFormDialog.vue, UpdateOrgDetailsDialog.vue).
 */
export async function triggerDashboardDigestNow({ scope_type, scope_id }) {
  try {
    const { data, errors } = await client.graphql({
      query: triggerDashboardDigestNowMutation,
      variables: { input: { scope_type, scope_id } },
    })

    if (errors?.length) {
      throw new Error(errors[0].message)
    }

    return parseAwsJson(data?.triggerDashboardDigestNow)
  } catch (error) {
    return {
      status: 'ERROR',
      message: getApiMessage(error, 'Could not send the digest right now.'),
    }
  }
}
